import scrollama from 'scrollama';

import domReady from '../utils/domReady';

const logo_anim = () => {
  domReady(() => {
    const headerEl = document.querySelector('header');
    const logoTextEl = document.querySelector('.c-logo__text');
    if (logoTextEl) {
      headerEl.style.setProperty('--logo-text-width', logoTextEl.getBoundingClientRect().width + 'px')
    }
    const scroll = new scrollama();

    scroll
      .setup({
        step: document.body,
        offset: 0.95,
      })
      .onStepExit(res => {
        const { direction } = res;

        if (direction === 'down') {
          headerEl.classList.add('is-scrolled')
        }
      })
      .onStepEnter(res => {
        const { direction } = res;

        if (direction === 'up') {
          headerEl.classList.remove('is-scrolled')
        }
      })

  })
}

logo_anim();
